import { Helmet } from "react-helmet";
import Navbar from "../../../components/Navbar/Navbar";
import WhatsAppWidget from "../../../components/Navbar/Whatsapp";
import Banner from "../../../components/body/projectPageComponents/Banner";
import Overview from "../../../components/body/projectPageComponents/Overview";
import Pricing from "../../../components/body/projectPageComponents/Pricing";
import Gallery from "../../../components/body/projectPageComponents/Gallery";
import Location from "../../../components/body/projectPageComponents/Location";
import Highlights from "../../../components/body/projectPageComponents/Highlights";
import SiteVisitBanner from "../../../components/body/projectPageComponents/SiteVisitBanner";
import FloorPlans from "../../../components/body/projectPageComponents/FloorPlans";
import Amenities from "../../../components/body/projectPageComponents/Amenities";
import Faq from "../../../components/body/projectPageComponents/Faq";
import SimilarProject from "../../../components/body/projectPageComponents/SimilarProject";

import { projectsganga } from "../../../data/projects/ganga/data";
import Main_Footer from "../../../components/footer/IndiaFooter/Main_Footer";

export const Serio = () => {
  const {
    serio: {
      form_data,
      whatsapp,
      bannerdata,
      overview,
      pricing,
      floor_plan,
      highlights,
      location,
      gallery,
      faq,
    },
  } = projectsganga;

  if (
    !bannerdata ||
    !overview ||
    !pricing ||
    !floor_plan ||
    !highlights ||
    !location ||
    !gallery ||
    !faq
  ) {
    return <div>Loading...</div>; // or an error page, depending on your needs
  }

  return (
    <>
      <Helmet>
        <title>
          Ganga Serio Kharadi Pune | Premium 2 & 3 BHK Luxury Apartments by Goel
          Ganga
        </title>
        <meta
          name="description"
          content="Ganga Serio in Kharadi, Pune – premium 2 & 3 BHK apartments by Goel Ganga Developments. Enjoy world-class amenities, river views, and prime connectivity to IT parks and business hubs. Book your dream home today."
        />
        <meta name="robots" content="index, follow" />
        <link
          rel="canonical"
          href="https://propertystation.in/ganga-serio-kharadi-pune"
        />
      </Helmet>

      <WhatsAppWidget whatsappdata={whatsapp} />
      <Navbar />

      <div className="mt-20">
        <Banner
          bannerDesktopImage={bannerdata.bannerDesktopImage}
          bannerMobileImage={bannerdata.bannerMobileImage}
          data={bannerdata.data}
          formData={form_data}
        />
        <Overview overviewData={overview} stripdata={overview.stripdata} />
        <SiteVisitBanner formData={form_data} />
        <Pricing pricingData={pricing} formData={form_data} />
        <FloorPlans floorPlans={floor_plan} formData={form_data} />
        <Highlights hightlightData={highlights} formData={form_data} />
        <Amenities />
        <Location location={location} />
        <Gallery galleryData={gallery} />
        <Faq faqdata={faq} />
        {/* <SimilarProject Similarprojects={similar} /> */}
        <Main_Footer />
      </div>
    </>
  );
};
